import { useQuery } from '@tanstack/react-query'
import { getRouteApi, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { safeRedirect, useDocumentTitle } from '@/shared/lib'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/shared/ui'

import { authSettingsQuery } from '../api/settings-api'
import { SignInForm } from '../components/sign-in-form'

import '../i18n'

// Read through the route API so the feature imports nothing from `src/routes/`.
const route = getRouteApi('/_public/login')

export function LoginPage() {
  const { t } = useTranslation(['auth', 'common'])
  const { returnTo } = route.useSearch()
  // Registration is mounted at the provider's boot, so a closed one 404s. The
  // link is only offered when the provider says it is open.
  const { data: settings } = useQuery(authSettingsQuery())

  // Called here rather than inherited from `PageHeader`: this page heads
  // itself with a `CardTitle`, and without the hook the tab kept whatever
  // `index.html` shipped with — the bare product name, on the one screen a
  // user is most likely to have open beside others.
  useDocumentTitle(t('common:auth.signInTitle'))

  return (
    <Card className="w-modal-confirm max-w-full">
      <CardHeader>
        <CardTitle>{t('common:auth.signInTitle')}</CardTitle>
        <CardDescription>{t('auth:signIn.description')}</CardDescription>
      </CardHeader>

      <CardContent className="flex flex-col gap-5">
        {/* Absolute URLs are rejected here, not after sign-in — otherwise this
            is an open redirect. */}
        <SignInForm returnTo={safeRedirect(returnTo)} />

        {settings?.isRegistrationOpen === true && (
          <p className="text-caption text-muted-foreground">
            {t('auth:signIn.noAccount')}{' '}
            <Link to="/register" className="text-foreground underline underline-offset-4">
              {t('auth:signIn.register')}
            </Link>
          </p>
        )}
      </CardContent>
    </Card>
  )
}
